import { useRecoveryAccountContext } from "../../../Contexts/RecoveryAccountContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { CircularProgress } from "@mui/material";
import Button from "../../../Components/Button";
import { useEffect, useState } from "react";
import OtpField from "../../../Components/OtpField";
import axios from "axios";
import { baseUrl } from "../../../utilities/configurations";

const MaxicareCardVerifyOTP = () => {
  const {
    setOldMobileNumber,
    setMobileNumber,
    setOtpErrorMsg,
    setCardNumber,
    setMiddleName,
    setSuffixName,
    mobileNumber,
    setIsLoading,
    setFirstName,
    setLastName,
    otpErrorMsg,
    isLoading,
    navigate,
    setEmail,
    setOtp,
    otp,
  } = useRecoveryAccountContext();

  const handleBack = () => {
    navigate(-1);
  };

  const handleVerifyOTP = async (e) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        baseUrl + `/otp/verify-otp`,
        {
          otp: otp,
        },
        { withCredentials: true }
      );
      if (response.data.status) {
        setEmail("");
        setOldMobileNumber("");
        setCardNumber("");
        setFirstName("");
        setMiddleName("");
        setLastName("");
        setSuffixName("");
        setMobileNumber("");
        setOtp("");
        setIsLoading(false);
        navigate("/recovery-account/maxicare-card-number/success", {
          replace: true,
        });
      }
      if (response.data.status === false) {
        setOtpErrorMsg("Oops! Incorrect OTP. Please try again");
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
    setOtpErrorMsg("");
  };

  const [counter, setCounter] = useState(30);

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const resendOtp = async (e) => {
    try {
      const ip = await axios.get("https://api.ipify.org/?format=json");
      const city = await axios.get(
        `https://ipapi.co/${JSON.stringify(ip.data.ip).replaceAll(
          '"',
          ""
        )}/json/`
      );
      const sendOtp = await axios.post(baseUrl + `/otp/send-mobile-otp`, {
        phoneNo: mobileNumber,
        ipAddress: JSON.stringify(ip.data.ip).replaceAll('"', ""),
        location: JSON.stringify(city.data.city).replaceAll('"', ""),
      });
      if (sendOtp.data.status) {
        setCounter(30);
      } else {
        console.log(sendOtp);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" || event.key === " ") {
      callback();
    }
  };
  return (
    <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
      <div className="flex flex-col w-full sm:w-148 sm:bg-white min-h-screen sm:min-h-0 items-start sm:items-center rounded-xl sm:mt-24 ">
        <div className="w-full grid grid-cols-1 divide-y">
          <div className="p-4">
            <KeyboardArrowLeftIcon
              className="absolute cursor-pointer "
              onClick={handleBack}
            />
            <div className="text-center font-semibold text-[#1F2328]">
              Recover account
            </div>
          </div>

          <div className="p-4">
            <div className="text-[#1F2328] text-2xl font-bold">
              Let's verify your mobile number
            </div>
            <div className="flex flex-row mt-1">
              <div className=" text-[#60656D]">
                Verify your account by entering the one-time password sent to{" "}
                {/* Add a space before the span element */}
                <span className="text-[#1F2328] font-semibold ml-1">
                  +63 9{mobileNumber.substr(1, 5).replace(/./g, "*")}
                  {mobileNumber.substr(6, 9)}
                </span>
              </div>
            </div>

            <div className="mt-3">
              <OtpField
                value={otp}
                onChange={handleOtpChange}
                onSubmit={(e) =>
                  otp.length < 6 || isLoading ? null : handleVerifyOTP
                }
                hasErrored={otpErrorMsg}
              />
              <span className="text-sm text-[#D32F2F]">{otpErrorMsg}</span>
            </div>
            <div className="flex flex-row mt-3">
              <div className="text-sm text-[#60656D]">
                Didn't get the password?{" "}
                <button
                  className={`ml-1 ${
                    counter === 0 ? "cursor-pointer text-[#0947AB]" : null
                  }`}
                  onClick={counter === 0 ? resendOtp : null}
                  onKeyDown={(event) =>
                    handleKeyDown(event, () =>
                      counter === 0 ? resendOtp : null
                    )
                  }
                  tabIndex={0}
                >
                  {counter !== 0 ? `Resend (in ${counter} sec)` : "Resend OTP"}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white flex-grow" />
        <div className="flex flex-col sm:items-end items-center w-full px-4 mb-3">
          <Button
            disabled={otp.length < 6 || isLoading}
            className={`w-full h-12 mt-2 ${
              otp.length < 6 || isLoading
                ? `text-[#A3A7AB] bg-[#F6F7F7]`
                : `text-white`
            }`}
            onClick={handleVerifyOTP}
          >
            {isLoading ? <CircularProgress size={"1rem"} /> : "Verify"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MaxicareCardVerifyOTP;
